import { motion } from "framer-motion";

export default function SectionHeading({
  eyebrow,
  title,
  intro,
  align = "left",
  dark = true,
  titleAccent,
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className={[
        align === "center" ? "text-center mx-auto max-w-3xl" : "max-w-3xl",
        "mb-12 lg:mb-16",
      ].join(" ")}
    >
      {eyebrow && (
        <div className="flex items-center gap-3 mb-4">
          <span className="h-px w-8 bg-messinger-orange" />
          <span className="label-eyebrow">{eyebrow}</span>
        </div>
      )}
      <h2
        className={[
          "font-heading font-semibold tracking-tight text-balance text-3xl sm:text-4xl lg:text-5xl leading-[1.05]",
          dark ? "text-white" : "text-messinger-blue",
        ].join(" ")}
      >
        {title}
        {titleAccent && (
          <span className="text-messinger-orange"> {titleAccent}</span>
        )}
      </h2>
      {intro && (
        <p
          className={[
            "mt-5 text-base lg:text-lg leading-relaxed",
            dark ? "text-white/65" : "text-messinger-dark/70",
          ].join(" ")}
        >
          {intro}
        </p>
      )}
    </motion.div>
  );
}
